import React, { useContext, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import StyledAppBar from "./StyledAppBar";
import useDialog from "../../../hooks/useDialog";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@material-ui/core";
import labels from "../../../helpers/labels.json";
import { PrimaryOutlinedCTAButton } from "../../common/Buttons";
import { TranslaterContext } from "../../../providers/TranslaterProvider";
import { sanitize } from "dompurify";
import styled from "styled-components";
import theme from "../../../assets/theme";
import COLORS from "../../../assets/Colors";
import useViewer from "../../../hooks/useViewer";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    width: "100vw",
    minHeight: "100vh",
    overflow: "auto",
  },
  content: {
    flexGrow: 1,
    //marginTop: 74,
    overflowX: "hidden",
    // eslint-disable-next-line no-useless-computed-key
    ["@media (max-width:600px)"]: {
      width: "100%",
    },
  },
}));

export function Header({
  children,
  showSidebar = false,
  selectedItem,
  NavPages = false,
  hideLinks = false,
  LandingPage = false,
  selectedSubItem = "",
  hideIcon = false,
  showHeader = true,
}) {
  const classes = useStyles();
  const { state, setState } = useDialog();
  const { translaterOpen } = useContext(TranslaterContext);
  const { password } = useViewer();
  const [showDrawer, setShowDrawer] = useState(false);

  return (
    <div className={classes.root}>
      <CssBaseline />
      {showHeader && (
        <StyledAppBar
          NavPages={NavPages}
          {...{
            hideLinks,
            LandingPage,
            setShowDrawer,
            showDrawer,
            selectedItem,

            hideIcon,
            password,
          }}
          selectedSubItem={"live"}
        />
      )}
      <main
        className={classes.content}
        style={translaterOpen ? { marginTop: `40px !important` } : {}}
      >
        {children}
      </main>

      {/* DialogComponent for term and condition and other links */}
      <Dialog
        open={!!state}
        maxWidth={"md"}
        onClose={() => setState("")}
        disableBackdropClick
        scroll={"body"}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title">
          {state === "T&C" && "Terms and Conditions"}
        </DialogTitle>
        <DialogContent dividers>
          <DialogContentText id="scroll-dialog-description" tabIndex={-1}>
            <div style={{ paddingBottom: 15 }}>
              {state === "T&C" && (
                <P
                  style={{ width: "100%" }}
                  dangerouslySetInnerHTML={{
                    __html: sanitize(labels["landing.T&C"]),
                  }}
                />
              )}
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <PrimaryOutlinedCTAButton
            style={{
              marginRight: 30,
              height: 39,
              width: 124,
              padding: "11px 38px",
            }}
            onClick={() => setState("")}
          >
            Agree
          </PrimaryOutlinedCTAButton>
        </DialogActions>
      </Dialog>
      {/* DialogComponent */}
    </div>
  );
}

export const LargeSidebar = styled.div`
  display: none;
  @media ${theme?.breakpoints?.sm_up} {
    display: block;
  }
`;

export const P = styled.p`
  font-family: ${theme.fonts.primaryFontRegular};
  color: ${COLORS.COLOR_DARK};
  font-size: 16px;
  line-height: 1.56;
  width: 978px;
  height: 217px;
  cursor: default;
  margin-top: 20px;
  & p {
    margin-top: 20px;
  }
  & div {
    margin-left: 40px;
    & span {
      margin-right: 20px;
    }
    @media (max-width: 600px) {
      margin-left: 20px;
      font-size: 14px;
      & span {
        margin-right: 10px;
      }
    }
  }
  @media (max-width: 1024px) {
    width: 80%;
  }
`;
